var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOnSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99968 0.598145C4.36317 0.598145 1.25759 2.86005 -0.000640869 6.05291C1.25759 9.24577 4.36317 11.5077 7.99968 11.5077C11.6362 11.5077 14.7418 9.24577 16 6.05291C14.7418 2.86005 11.6362 0.598145 7.99968 0.598145ZM7.99968 9.68942C5.99233 9.68942 4.36317 8.06027 4.36317 6.05291C4.36317 4.04556 5.99233 2.4164 7.99968 2.4164C10.007 2.4164 11.6362 4.04556 11.6362 6.05291C11.6362 8.06027 10.007 9.68942 7.99968 9.68942ZM7.99968 3.87101C6.79236 3.87101 5.81778 4.84559 5.81778 6.05291C5.81778 7.26023 6.79236 8.23482 7.99968 8.23482C9.20701 8.23482 10.1816 7.26023 10.1816 6.05291C10.1816 4.84559 9.20701 3.87101 7.99968 3.87101Z",
    fill: "#9E9288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOnSm);
export default __webpack_public_path__ + "static/media/eye-on-sm.31b01946d59d656d6333829bc39915c6.svg";
export { ForwardRef as ReactComponent };